<template>
    <SwipeableBottomSheet ref="swipeableBottomSheet">
        <template v-slot:header>
            <div id="mobile-issue-view-header">
                <b>#{{ issue.code }}</b> {{ issue.title }}
            </div>
        </template>
        <template v-slot:content>
            <vue-custom-scrollbar :settings="{ suppressScrollX: true }" class="w-100 h-100">
                <div id="mobile-issue-view-content" v-if="!isLoading">
                    <div class="status-container">
                        <div class="issue-status-radio">
                            <div class="issue-status-radio-option right" :class="{ selected: issue.status == 'open' }" @click="updateIssueStatus('open')">
                                <icon name="exclamation-circle" color="white" scale="0.75" class="mr-1" />
                                <p>{{ $t('keyword23') }}</p>
                            </div>
                            <div
                                class="issue-status-radio-option right left"
                                :class="{ selected: issue.status == 'in_review' }"
                                @click="updateIssueStatus('in_review')"
                            >
                                <icon name="ci-issue-viewed" color="white" scale="0.75" class="mr-1" />
                                <p>{{ $t('keyword24') }}</p>
                            </div>
                            <div class="issue-status-radio-option left" :class="{ selected: issue.status == 'closed' }" @click="updateIssueStatus('closed')">
                                <icon name="check-circle" color="white" scale="0.75" class="mr-1" />
                                <p>{{ $t('keyword25') }}</p>
                            </div>
                        </div>

                        <p class="description text-10">
                            {{ issue.text }}
                        </p>
                    </div>
                    <div class="general-info-container">
                        <h5 class="section-title">{{ $t('Components_Viewer_UI_Mobile_IssueView_1') }}</h5>

                        <div class="thumbnail" :style="`background-image: url(${issue.thumbnail})`"></div>

                        <h6 class="sub-section-title">{{ $t('Components_Viewer_UI_Mobile_IssueView_2') }}</h6>
                        <p v-if="issue.created_by">{{ issue.created_by.name }} {{ issue.created_by.surname }}</p>

                        <h6 class="sub-section-title">{{ $t('Components_Viewer_UI_Mobile_IssueView_3') }}</h6>
                        <p v-if="issue.subjects">
                            {{ formattedSubjects }}
                        </p>

                        <h6 class="sub-section-title">{{ $t('keyword82') }}</h6>
                        <div class="tags" v-if="issue.tags">
                            <b-avatar-group size="16px" overlap="0.3" variant="secondary-2">
                                <b-avatar
                                    v-for="tag in tagsArray.slice(0, 3)"
                                    :key="tag.id"
                                    :src="tag.user ? tag.user.image : ''"
                                    v-b-tooltip.hover
                                    :title="tag.user ? tag.user.name + ' ' + tag.user.surname : tag.email"
                                />
                                <b-avatar v-if="tagsArray.length > 4" :text="'+' + (tagsArray.length - 4)" v-b-tooltip.hover :title="remainingTags"></b-avatar>
                            </b-avatar-group>
                        </div>

                        <div class="d-flex justify-content-between">
                            <div>
                                <h6 class="sub-section-title">{{ $t('Components_Viewer_UI_Mobile_IssueView_4') }}</h6>
                                <p>
                                    {{ issue.created_at }}
                                </p>
                            </div>

                            <div>
                                <h6 class="sub-section-title">{{ $t('Components_Viewer_UI_Mobile_IssueView_5') }}</h6>
                                <p>
                                    {{ issue.created_at }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="d-flex justify-content-center align-items-center h-100" v-else-if="isLoading">
                    <b-spinner small />
                </div>
            </vue-custom-scrollbar>
        </template>
    </SwipeableBottomSheet>
</template>
<script>
// ===================
// Components
// ===================
import SwipeableBottomSheet from '@/components/360Viewer/UI/Mobile/SwipeableBottomSheet'
import vueCustomScrollbar from 'vue-custom-scrollbar'

// ===================
// Queries & Mutations
// ===================
// import updateIssueStatus from '@/graphql/mutations/issues/updateIssueStatus'

/**
 * Summary.
 * Mobile view for whe user clicks one issue
 *
 */

export default {
    name: 'IssueView',
    components: {
        SwipeableBottomSheet,
        vueCustomScrollbar,
    },
    computed: {
        remainingTags() {
            let tagsArray = this.tagsArray
            let remainingMembersArray = []
            let remainingMembers = []

            remainingMembersArray = tagsArray.slice(3)
            remainingMembersArray.forEach((member) => {
                if (member.user) {
                    remainingMembers.push(member.user.name + ' ' + member.user.surname)
                }
            })

            return remainingMembers.join(', ')
        },
        tagsArray() {
            let tagsArray = []
            this.issue.tags.forEach((tag) => {
                tag.members.forEach((member) => {
                    tagsArray.push(member)
                })
            })
            return tagsArray
        },
        formattedSubjects() {
            return this.issue.subjects.map((s) => s.code).join(', ')
        },
    },
    data() {
        return {
            issue: {},
            isLoading: false,
            error: false,
        }
    },
    methods: {
        updateIssueStatus(status) {
            this.issue.status = status
            this.$apollo
                .mutate({
                    mutation: updateIssueStatus,
                    variables: {
                        id: this.issue.id,
                        status,
                    },
                })
                .catch((err) => {
                    this.$notify({
                        group: 'foo',
                        type: 'error',
                        title: this.$t('Projects_notify_error_title3'),
                        text: this.$t('Projects_notify_error_text66'),
                    })
                })
        },

        // PUBLIC METHODS
        /**
         * Summary.
         * Opens the bottom sheet.
         *
         * @param {Object} issue - the issue to be presented
         */
        open(issue) {
            this.issue = issue
            this.$refs.swipeableBottomSheet.setState('open')
        },

        /**
         * Summary.
         * Closes the bottom sheet.
         *
         */
        close() {
            this.issue = {}
            this.$refs.swipeableBottomSheet.setState('close')
        },
    },
}
</script>
<style lang="scss" scoped>
@import '@/scss/components/360Viewer/UI/Mobile/issue-view.scss';
</style>
